document.addEventListener("DOMContentLoaded", function (e) {
  let tooltipElem;
  let tooltipTrigger = document.querySelectorAll(".new-tooltip__trigger");

  function isMobileOrTablet() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  tooltipTrigger.forEach(function (elem) {
    elem.onmouseover = function (event) {
      if (isMobileOrTablet()) return;

      let target = event.target;
      let tooltipHtml = target.dataset.tooltip;
      if (!tooltipHtml) return;

      tooltipElem = document.createElement("div");
      tooltipElem.className = "new-tooltip";
      tooltipElem.innerHTML = tooltipHtml;
      document.body.append(tooltipElem);

      positionTooltip(target);
    };

    elem.addEventListener("click", function (event) {
      if (!isMobileOrTablet()) return;

      event.preventDefault();

      let target = event.target;

      if (tooltipElem && tooltipElem.target === target) {
        tooltipElem.remove();
        tooltipElem = null;
        return;
      }

      let tooltipHtml = target.dataset.tooltip;
      if (!tooltipHtml) return;

      tooltipElem = document.createElement("div");
      tooltipElem.className = "new-tooltip";
      tooltipElem.innerHTML = tooltipHtml;
      tooltipElem.target = target;
      document.body.append(tooltipElem);

      positionTooltip(target);
    });
  });

  tooltipTrigger.forEach(function (elem) {
    elem.onmouseout = function (e) {
      if (tooltipElem && !isMobileOrTablet()) {
        tooltipElem.remove();
        tooltipElem = null;
      }
    };
  });

  document.addEventListener("click", function (event) {
    if (
      tooltipElem &&
      !tooltipElem.contains(event.target) &&
      !event.target.closest(".new-tooltip__trigger")
    ) {
      tooltipElem.remove();
      tooltipElem = null;
    }
  });
  function positionTooltip(target) {
    let coords = target.getBoundingClientRect();

    let left = coords.left + (target.offsetWidth - tooltipElem.offsetWidth) / 2;
    if (left < 0) left = 0;

    let top = coords.top - tooltipElem.offsetHeight - 5;
    if (top < 0) {
      top = coords.top + target.offsetHeight + 5;
    }

    tooltipElem.style.left = left + "px";
    tooltipElem.style.top = top + "px";
    tooltipElem.style.zIndex = "1";
  }
});
